import SVGApprove from "../SVGApprove";
import SVGCancel from "../SVGCancel";

import { ButtonLink } from "~/components/Button";
import HasPermission from "~/components/HasPermission";
import { ViewerPermissions } from "~/contexts/ViewerContext";
import useCurrentViewerPermissions from "~/hooks/useCurrentViewerPermissions";

type Props = {
  onClickOpenAccept: () => void;
  onClickOpenDecline: () => void;
  disabled?: boolean;
  isAddressConfirmationNeeded: boolean;
  showAcceptButton: boolean;
};

export default function BeneficiaryAcceptDeclineButton({
  onClickOpenAccept,
  onClickOpenDecline,
  showAcceptButton = true,
  disabled = false,
  isAddressConfirmationNeeded,
}: Props) {
  const viewerPermissions = useCurrentViewerPermissions();
  const hasPermissionToConfirmAddress = viewerPermissions.includes(ViewerPermissions["transactions.confirm"]);

  if (isAddressConfirmationNeeded && !hasPermissionToConfirmAddress) {
    return null;
  }

  return (
    <>
      {showAcceptButton && (
        <HasPermission permission={ViewerPermissions["transactions.accept"]}>
          <ButtonLink
            title="Accept incoming transfers"
            style={{ padding: "0 0.5rem" }}
            color="success"
            onClick={onClickOpenAccept}
            disabled={disabled}
          >
            <SVGApprove style={{ fontSize: "1.5rem" }} data-testid="acceptButton" />
          </ButtonLink>
        </HasPermission>
      )}

      <HasPermission permission={ViewerPermissions["transactions.decline"]}>
        <ButtonLink
          title="Decline incoming transfers"
          style={{ padding: "0 0.5rem" }}
          color="success"
          onClick={onClickOpenDecline}
          disabled={disabled}
        >
          <SVGCancel style={{ fontSize: "1.5rem" }} data-testid="declineButton" />
        </ButtonLink>
      </HasPermission>
    </>
  );
}
